import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderUser from "../Components/Manage Users/hearderUser";
import KioskUsers from "../Components/Manage Users/koiskUser";
import WebUsers from "../Components/Manage Users/webUser";
import ListUsers from "../Components/Manage Users/listUsers";
import ViewUsers from "../Components/Manage Users/viewUsers";

const UsersRoutes = () => {
  return (
    <Routes>
      <Route path="/manage_users" element={<HeaderUser></HeaderUser>}></Route>
      <Route path="/app_users" element={<ListUsers></ListUsers>}></Route>
      <Route path="/kiosk_users" element={<KioskUsers></KioskUsers>}></Route>
      <Route path="/web_users" element={<WebUsers></WebUsers>}></Route>
      <Route path="/manage_users/view/:id" element={<ViewUsers></ViewUsers>}></Route>
    </Routes>
  );
};

export default UsersRoutes;
